(function () {
    "use strict";

    var code = new URLSearchParams(window.location.search).get("pdt-highlight");
    if (!code || !/^[a-z0-9_-]+$/i.test(code)) return;

    var component =
        document.querySelector(
            ".shopify-section--collection-banner [data-paid-traffic-component]",
        ) ||
        document.querySelector(
            ".shopify-section--collection-banner-presentation [data-paid-traffic-component]",
        ) || document.querySelector("[data-paid-traffic-component]");
    if (!component) return;

    var breadcrumb =
        document.querySelector(
            ".shopify-section--collection-banner .breadcrumb",
        ) ||
        document.querySelector(
            ".shopify-section--collection-banner-presentation .breadcrumb",
        ) || document.querySelector(".breadcrumb");
    if (breadcrumb) {
        breadcrumb.classList.remove("breadcrumb--floating");
        breadcrumb.classList.add("breadcrumb--in-flow");
        breadcrumb.insertAdjacentElement("afterend", component);
    }
    document
        .querySelectorAll(".shopify-section--paid-traffic-component")
        .forEach(function (section) {
            section.style.display = "none";
        });

    document
        .querySelectorAll(
            "[data-collection-description], .collectionDescription",
        )
        .forEach(function (description) {
            description.hidden = true;
            description.style.display = "none";
        });

    var start =
        window.requestIdleCallback ||
        function (callback) {
            window.setTimeout(callback, 1);
        };

    function escapeHtml(value) {
        var element = document.createElement("div");
        element.textContent = value == null ? "" : value;
        return element.innerHTML;
    }

    function formatMoney(price, currency) {
        var amount = Number(price || 0);
        var useCurrencyCode = component.dataset.currencyCodeEnabled === "true";
        var moneyFormat = useCurrencyCode
            ? component.dataset.moneyFormatWithCurrency ||
              component.dataset.moneyFormat
            : component.dataset.moneyFormat;
        moneyFormat = moneyFormat || "{{amount}}";
        var amountWithDecimals = amount.toFixed(2);
        var amountWithComma = amountWithDecimals.replace(".", ",");
        var amountWithoutDecimals = Math.round(amount).toString();
        var amountWithThousands = amountWithDecimals.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ",",
        );
        var amountWithCommaThousands = amountWithComma.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            " ",
        );

        return moneyFormat
            .replace("{{amount}}", amountWithThousands)
            .replace("{{amount_no_decimals}}", amountWithoutDecimals)
            .replace(
                "{{amount_with_comma_separator}}",
                amountWithCommaThousands,
            )
            .replace(
                "{{amount_no_decimals_with_comma_separator}}",
                amountWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            )
            .replace(
                "{{amount_with_apostrophe_separator}}",
                amountWithDecimals
                    .replace(/\B(?=(\d{3})+(?!\d))/g, "'")
                    .replace(".", ","),
            )
            .replace(
                "{{amount_no_decimals_with_space_separator}}",
                amountWithoutDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            )
            .replace(
                "{{amount_with_space_separator}}",
                amountWithCommaThousands,
            )
            .replace(
                "{{amount_with_period_and_space_separator}}",
                amountWithDecimals
                    .replace(".", ",")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            );
    }

    function getAvailableVariants(product) {
        return (product.variants || []).filter(function (variant) {
            return variant.available !== false;
        });
    }

    function getColorCount(product) {
        var colors = {};
        getAvailableVariants(product).forEach(function (availableVariant) {
            var color =
                availableVariant.option1 ||
                (availableVariant.options && availableVariant.options[0]);
            if (color) colors[String(color).trim().toLowerCase()] = true;
        });
        return Object.keys(colors).length;
    }

    function renderPrice(product, variant) {
        var availableVariants = getAvailableVariants(product);
        var price = Number(
            variant && variant.price != null
                ? variant.price
                : product.price || 0,
        );
        var compareAt = Number(
            variant && variant.compare_at_price != null
                ? variant.compare_at_price
                : product.compare_at_price || 0,
        );
        var priceVaries = availableVariants.some(function (availableVariant) {
            return (
                Number(availableVariant.price) !==
                Number(availableVariants[0] && availableVariants[0].price)
            );
        });

        if (priceVaries && compareAt) {
            var cheapestVariant = availableVariants.reduce(function (
                cheapest,
                current,
            ) {
                return !cheapest ||
                    Number(current.price) < Number(cheapest.price)
                    ? current
                    : cheapest;
            }, null);
            var cheapestPrice = Number(
                (cheapestVariant && cheapestVariant.price) || price,
            );
            var cheapestCompareAt = Number(
                (cheapestVariant && cheapestVariant.compare_at_price) || 0,
            );
            var priceMin = formatMoney(cheapestPrice, product.currency);
            if (cheapestPrice < cheapestCompareAt) {
                return (
                    '<span class="price price--highlight">' +
                    priceMin +
                    "</span>" +
                    '<span class="price price--compare">' +
                    formatMoney(cheapestCompareAt, product.currency) +
                    "</span>"
                );
            }
            return '<span class="price">' + priceMin + "</span>";
        }

        if (price < compareAt) {
            return (
                '<span class="price price--highlight">' +
                formatMoney(price, product.currency) +
                "</span>" +
                '<span class="price price--compare">' +
                formatMoney(compareAt, product.currency) +
                "</span>"
            );
        }

        return (
            '<span class="price">' +
            formatMoney(price, product.currency) +
            "</span>"
        );
    }

    function findVariant(product, modelCode) {
        return (product.variants || []).find(function (variant) {
            var firstOption =
                variant.option1 || (variant.options && variant.options[0]);
            return (
                firstOption &&
                String(firstOption).trim().toLowerCase() === modelCode
            );
        });
    }

    function getImages(product, variant) {
        var images = (product.images || [])
            .filter(Boolean)
            .map(function (image) {
                return typeof image === "string" ? image : image && image.src;
            })
            .filter(Boolean);
        return images.slice(0, 3);
    }

    function getQuickBuyUrl(product, view, variant) {
        var collectionUrl = new URL(
            component.dataset.productsUrl,
            window.location.origin,
        );
        collectionUrl.pathname =
            collectionUrl.pathname.replace(/\/$/, "") +
            "/products/" +
            encodeURIComponent(product.handle);
        var quickBuyUrl = new URL(
            collectionUrl.pathname,
            window.location.origin,
        );
        new URLSearchParams(window.location.search).forEach(
            function (value, parameter) {
                if (
                    parameter !== "pdt-highlight" &&
                    parameter !== "view" &&
                    parameter !== "variant" &&
                    parameter !== "section_id" &&
                    parameter !== "sections"
                ) {
                    quickBuyUrl.searchParams.set(parameter, value);
                }
            },
        );
        quickBuyUrl.searchParams.set("view", view);
        if (variant && variant.id)
            quickBuyUrl.searchParams.set("variant", variant.id);

        return quickBuyUrl.pathname + quickBuyUrl.search;
    }

    function findProduct(products) {
        return (products || []).reduce(function (match, product) {
            if (match) return match;
            var variant = findVariant(product, code.toLowerCase());
            return variant ? { product: product, variant: variant } : null;
        }, null);
    }

    function findProductInCollection(productsUrl, page) {
        productsUrl.searchParams.set("page", page);

        return fetch(productsUrl, { credentials: "same-origin" })
            .then(function (response) {
                return response.ok ? response.json() : null;
            })
            .then(function (data) {
                var products = data && data.products;
                var match = findProduct(products);
                if (match || !products || products.length < 250 || page >= 20)
                    return match;
                return findProductInCollection(productsUrl, page + 1);
            });
    }

    function render(product, variant) {
        var images = getImages(product, variant);
        if (!images.length) return;

        var productUrl = "/products/" + encodeURIComponent(product.handle);

        var imageMarkup = images
            .map(function (image, index) {
                return (
                    '<a class="paid-traffic-component__image-link" href="' +
                    escapeHtml(productUrl) +
                    '">' +
                    '<img class="paid-traffic-component__image" src="' +
                    escapeHtml(image) +
                    '" alt="' +
                    escapeHtml(product.title) +
                    '" loading="lazy"' +
                    (index === 0 ? ' fetchpriority="low"' : "") +
                    "></a>"
                );
            })
            .join("");
        var rating = product.metafields && product.metafields.rating;
        var colorCount = getColorCount(product);
        var colorsMarkup =
            colorCount > 1
                ? '<p class="paid-traffic-component__colors">' +
                  escapeHtml(
                      (component.dataset.colorsLabel || "").replace(
                          "__COUNT__",
                          colorCount,
                      ),
                  ) +
                  "</p>"
                : "";

        var quickBuyId =
            "paid-traffic-quick-buy-" +
            String(product.id || product.handle).replace(/[^a-z0-9_-]/gi, "-");
        var quickViewLabel = escapeHtml(component.dataset.quickViewLabel || "");
        var quickBuyControls =
            '<button is="toggle-button" loader type="button" aria-controls="' +
            quickBuyId +
            '-drawer" aria-expanded="false" class="button button--outline button--text button--full hidden-touch hidden-phone quick-add-to-card-button paid-traffic-component__quick-view-button">' +
            quickViewLabel +
            "</button>" +
            '<button is="toggle-button" type="button" aria-controls="' +
            quickBuyId +
            '-popover" aria-expanded="false" class="button button--outline button--text button--full hidden-no-touch hidden-phone paid-traffic-component__quick-view-button">' +
            quickViewLabel +
            "</button>" +
            '<button is="toggle-button" type="button" aria-controls="' +
            quickBuyId +
            '-popover" aria-expanded="false" class="button hidden-tablet-and-up paid-traffic-component__quick-view-button paid-traffic-component__mobile-quick-view-button">' +
            quickViewLabel +
            "</button>" +
            '<quick-buy-popover id="' +
            quickBuyId +
            '-popover" href="' +
            escapeHtml(getQuickBuyUrl(product, "quick-buy-popover", variant)) +
            '" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>' +
            '<quick-buy-drawer id="' +
            quickBuyId +
            '-drawer" href="' +
            escapeHtml(getQuickBuyUrl(product, "quick-buy-drawer", variant)) +
            '" class="drawer drawer--large drawer--quick-buy hidden-phone" append-body></quick-buy-drawer>';

        component.innerHTML =
            '<div class="paid-traffic-component__media">' +
            imageMarkup +
            "</div>" +
            '<div class="paid-traffic-component__details">' +
            '<p class="product-vendor paid-traffic-vendor">' +
            escapeHtml(product.vendor || "DECATHLON") +
            "</p>" +
            '<h2 class="product-meta__title heading h2 title-font-transform paid-traffic-title"><a class="paid-traffic-title-link" href="' +
            escapeHtml(productUrl) +
            '">' +
            escapeHtml(product.title) +
            "</a></h2>" +
            colorsMarkup +
            '<div class="price-list price-list--centered">' +
            renderPrice(product, variant) +
            "</div>" +
            '<div class="paid-traffic-component__actions"><a class="button button--primary button--small paid-traffic-component__view-details" href="' +
            escapeHtml(productUrl) +
            '">' +
            escapeHtml(component.dataset.viewDetailsLabel || "") +
            '</a><div class="paid-traffic-component__quick-form product-item__quick-form2">' +
            quickBuyControls +
            "</div></div>" +
            "</div>";
        component.classList.add("paid-traffic-component--loaded");
    }

    function load() {
        var productsUrl = new URL(
            component.dataset.productsUrl,
            window.location.origin,
        );
        productsUrl.pathname =
            productsUrl.pathname.replace(/\/$/, "") + "/products.json";
        productsUrl.searchParams.set("limit", "250");

        findProductInCollection(productsUrl, 1)
            .then(function (match) {
                if (match) render(match.product, match.variant);
            })
            .catch(function () {});
    }

    start(load, { timeout: 2000 });
})();
